module.exports = __webpack_public_path__ + "static/media/logout-icon.542f9599.svg";